import React from 'react'
import ItemList from '../ItemList/ItemList'

function ItemListContainer() {

    return (
        <>
            <ItemList />
        </>
    )
}

export default ItemListContainer